export default __webpack_public_path__ + "static/media/iconGunWater.7599b673.png";